export const MODULE_NAME = 'logos'; //BaseApi
export const LOGO = 'logos';
export const LOGOS = 'logos';
export const RELOAD_LOGOS = 'reloadLogos';
export const SAVE_LOGO = 'saveLogo';
export const SET_LOGO = 'setLogo';
export const SET_LOGOS = 'setLogoss';
export const LOGOS_HISTORY = 'logosHistory';
export const SET_LOGOS_HISTORY = 'setLogosHistory';
